import axiosInstance from '@/api/axiosInstance';
import { UpdateCoursePayload, UpdateCourseResponse } from './types';

/**
 * Update an existing course
 * PUT /api/learning-center/courses/:id
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const updateCourse = async (
  id: number,
  payload: UpdateCoursePayload
): Promise<UpdateCourseResponse> => {
  try {
    const response = await axiosInstance.put<UpdateCourseResponse>(
      `/api/learning-center/courses/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating course ${id}:`, error);
    throw error;
  }
};
